let func: (values?: any) => void = () => {};

const SubscriptionService = {
  call: (values?: any) => func(values),

  unsubscribe: () => (func = () => {}),

  subscribe: (fn: (values?: any) => void) => (func = fn),
};

export default SubscriptionService;
